import { render, staticRenderFns } from "./TabsDiscovery.vue?vue&type=template&id=78f14200&scoped=true"
import script from "./TabsDiscovery.vue?vue&type=script&lang=js"
export * from "./TabsDiscovery.vue?vue&type=script&lang=js"
import style0 from "./TabsDiscovery.vue?vue&type=style&index=0&id=78f14200&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f14200",
  null
  
)

export default component.exports